export const SETTINGS_TYPE_HIDE = 'hidden';
export const SETTINGS_TYPE_SHOW = 'show';
export const SETTINGS_TYPE_EDIT = 'edit';
